module.exports = __webpack_public_path__ + "img/map-locator.83180417.png";